<div class="app-main_outer" [class.auth-layout]="layout == 'none'">
  <div class="rc-container">
    <router-outlet></router-outlet>
  </div>
</div>
